<div class="equipment-calibration-status-widget">
  @if (widgetTitle) {
    <div class="widget-title-header">
      <h4 class="widget-title">{{ titleMeta.isCustom ? widgetTitle : (widgetTitle | translate) }}{{ titleMeta.tailPrefix }}{{ titleMeta.tailKey | translate }}{{ titleMeta.tail }}</h4>
      <app-widget-org-filter
        [orgLevelId]="orgLevelOverrideId"
        (orgLevelIdChange)="onOrgLevelOverrideChange($event)">
      </app-widget-org-filter>
    </div>
  }
  @if (widgetTitle) {
    <hr class="widget-divider">
  }

  <div class="widget-content">
    @if (isLoading) {
      <div class="loading-container">
        <div class="loading-spinner"></div>
      </div>
    }

    @if (error && !isLoading) {
      <div class="error-container">
        <span class="error-icon">&#9888;</span>
        <span>{{ error | translate }}</span>
      </div>
    }

    @if (!isLoading && !error && summary) {
      <div class="chart-section">
        <div class="chart-wrapper">
          <div class="chart-container">
            <canvas #chartCanvas></canvas>
            <div class="chart-center-label">
              <span class="total-count">{{ summary.total }}</span>
              <span class="total-label">{{ 'Total' | translate }}</span>
            </div>
          </div>
          <div class="chart-legend">
            <div class="legend-item">
              <span class="legend-dot" [style.background]="colors.overdue"></span>
              <span class="legend-text">{{ 'Overdue Calibration' | translate }}</span>
            </div>
            <div class="legend-item">
              <span class="legend-dot" [style.background]="colors.upcoming"></span>
              <span class="legend-text">{{ 'Upcoming Calibration' | translate }}</span>
            </div>
            <div class="legend-item">
              <span class="legend-dot" [style.background]="colors.calibrated"></span>
              <span class="legend-text">{{ 'Calibrated' | translate }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="lists-section">
        @if (summary.overdueItems?.length) {
          <div class="status-list">
            <div class="list-header overdue">
              <span class="status-dot overdue-dot"></span>
              <span class="list-title">{{ 'Overdue Calibration' | translate }}</span>
              <span class="list-count">({{ summary.overdueItems.length }})</span>
            </div>
            <div class="list-items">
              @for (item of summary.overdueItems; track trackById($index, item)) {
                <div class="list-item clickable"
                  (click)="navigateToDetail(item)">
                  <div class="item-info">
                    <span class="item-name">{{ item.name }}</span>
                    <span class="item-code">{{ item.equipmentCode }}</span>
                  </div>
                  <span class="item-badge overdue-badge">{{ item.daysOverdue }} {{ 'days overdue' | translate
                  }}</span>
                </div>
              }
            </div>
          </div>
        }
        @if (summary.upcomingItems?.length) {
          <div class="status-list">
            <div class="list-header upcoming">
              <span class="status-dot upcoming-dot"></span>
              <span class="list-title">{{ 'Due This Week' | translate }}</span>
              <span class="list-count">({{ summary.upcomingItems.length }})</span>
            </div>
            <div class="list-items">
              @for (item of summary.upcomingItems; track trackById($index, item)) {
                <div class="list-item clickable"
                  (click)="navigateToDetail(item)">
                  <div class="item-info">
                    <span class="item-name">{{ item.name }}</span>
                    <span class="item-code">{{ item.equipmentCode }}</span>
                  </div>
                  <span class="item-badge upcoming-badge">{{ item.calibrationDue | date:'MMM d' }}</span>
                </div>
              }
            </div>
          </div>
        }
        @if (!summary.overdueItems?.length && !summary.upcomingItems?.length) {
          <div class="no-items">
            {{ 'All equipment calibrations are up to date' | translate }}
          </div>
        }
      </div>
    }
  </div>
</div>
